// Small components of the networking UI shared by every part (feature spec 17, phase 1; spec 11 6.15).
import { Link } from 'react-router';
import type { WaitingFor } from '../api/types';
import { strings } from '../strings';
import { waitingWords } from './shared';

const s = strings.networks;

/** The words of a waiting run (6.15.17) with a link to the run it waits for. */
export function WaitingText({
  waitingFor,
  className,
}: {
  waitingFor: WaitingFor | null | undefined;
  className?: string;
}) {
  const words = waitingWords(waitingFor);
  if (
    waitingFor?.runId &&
    (waitingFor.reason === 'network-run' ||
      waitingFor.reason === 'deployment-run' ||
      waitingFor.reason === 'awaited-run')
  )
    return (
      <Link className={`link ${className ?? ''}`} to={`/runs/${waitingFor.runId}`}>
        {words}
      </Link>
    );
  return <span className={className}>{words}</span>;
}

/** The "Networking is switched off" page of `/networks…` while the gate is off (6.15.1). */
export function NetworkingSwitchedOff() {
  return (
    <div className="mx-auto max-w-[1240px] px-6 py-5">
      <h1 className="text-xl font-semibold">{s.nav.networks}</h1>
      <p className="mt-2 text-fg-muted">
        {s.switchedOff}{' '}
        <Link className="link" to="/blueprints">
          {s.goToBlueprints}
        </Link>
      </p>
    </div>
  );
}
